const urlAPI = process.env.REACT_APP_URL_API;
//const urlAPI = "https://server-api.azurewebsites.net"; //Remoto

export { urlAPI };
